import { useMemo } from "react";
import protectedAreasData from "json/protectedAreas.json";
import { MapRainforestProduct, MapProtectedArea } from "types/map";

const FORECO_DATA = protectedAreasData[0] as unknown as MapProtectedArea;

export const useMapForecoFetchProducts = () => {
  const getProductByTag = useMemo(
    () => (tag: string | null): MapRainforestProduct | undefined => {
      if (!tag || !FORECO_DATA.rainforestProducts) return undefined;
      return FORECO_DATA.rainforestProducts.find((p) => p.tags.includes(tag));
    },
    []
  );

  const getProductLabel = useMemo(
    () => (tag: string): string => {
      const product = FORECO_DATA.rainforestProducts?.find((p) => p.tags.includes(tag));
      return product?.label ?? tag;
    },
    []
  );

  return {
    getProductByTag,
    getProductLabel,
  };
};
